package pl.decks.personal.components.widgets.mode

import androidx.compose.runtime.Composable
import com.varabyte.kobweb.compose.ui.Modifier

data class ModeInputOption(
    val isSelected: Boolean,
    val onModeClicked: () -> Unit,
    val modifier: Modifier = Modifier,
    val content: @Composable () -> Unit,
)
